import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_90: FaireProductEntity = {
  token: "starter_collection_90",
  type: "product",
  name: "The Table Knives Set",
  brandName: "Material",
  imageUrl:
    "https://cdn.faire.com/fastly/af6fbdd9ac009dd8fe6c7a5a957480ab12b166c1e8ab18690dc7a3e30bf08bfb.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
